import React from 'react'
import { View, Text, StyleSheet, TouchableOpacity, ScrollView } from 'react-native'
import { useTheme } from '@/contexts/ThemeContext'
import { posts } from '@/content/blog/posts'
import { useRouter } from 'expo-router'

export default function BlogIndex() {
  const { colors } = useTheme()
  const router = useRouter()
  const formatDateBR = (s: string) => {
    const [y, m, d] = s.split('-')
    return `${d}/${m}/${y}`
  }

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    header: {
      paddingHorizontal: 24,
      paddingVertical: 32,
    },
    title: {
      fontSize: 28,
      fontFamily: 'Inter-Bold',
      color: colors.text,
      marginBottom: 8,
      textAlign: 'center',
    },
    subtitle: {
      fontSize: 16,
      fontFamily: 'Inter-Regular',
      color: colors.textSecondary,
      textAlign: 'center',
    },
    list: {
      paddingHorizontal: 24,
      paddingVertical: 24,
      gap: 20,
    },
    card: {
      borderWidth: 1,
      borderColor: colors.border,
      borderRadius: 12,
      overflow: 'hidden',
      backgroundColor: colors.surface,
    },
    image: {
      width: '100%',
      height: 'auto' as any,
      aspectRatio: 3000 / 1150,
      objectFit: 'cover' as any,
    },
    cardContent: {
      paddingHorizontal: 16,
      paddingVertical: 16,
      gap: 8,
    },
    cardTitle: {
      fontSize: 18,
      fontFamily: 'Inter-SemiBold',
      color: colors.text,
    },
    cardExcerpt: {
      fontSize: 14,
      fontFamily: 'Inter-Regular',
      color: colors.textSecondary,
    },
    cardMeta: {
      fontSize: 12,
      fontFamily: 'Inter-Regular',
      color: colors.textSecondary,
    },
    cardButton: {
      marginTop: 12,
      paddingVertical: 12,
      borderRadius: 10,
      alignItems: 'center',
      backgroundColor: colors.primary,
    },
    cardButtonText: {
      color: '#FFFFFF',
      fontSize: 14,
      fontFamily: 'Inter-SemiBold',
    },
  })

  return (
    <ScrollView style={styles.container} contentContainerStyle={{ paddingBottom: 40 }}>
      <View style={styles.header}>
        <h1 style={{ ...(styles.title as any), margin: 0 }}>Blog</h1>
        <p style={{ ...(styles.subtitle as any), margin: 0 }}>
          Dicas práticas para organizar despesas e viver sem perrengue financeiro
        </p>
      </View>

      <View style={styles.list}>
        {posts.map((post) => (
          <View key={post.slug} style={styles.card}>
            {post.coverImage ? (
              <img
                src={post.coverImage}
                alt={`Capa do artigo: ${post.title}`}
                loading="lazy"
                decoding="async"
                style={styles.image as any}
              />
            ) : null}
            <View style={styles.cardContent}>
              <Text style={styles.cardTitle}>{post.title}</Text>
              <Text style={styles.cardExcerpt}>{post.excerpt}</Text>
              <Text style={styles.cardMeta}>{formatDateBR(post.date)}</Text>
              <TouchableOpacity
                onPress={() => router.push(`/blog/${post.slug}`)}
                style={styles.cardButton}
                activeOpacity={0.8}
              >
                <Text style={styles.cardButtonText}>Ler artigo</Text>
              </TouchableOpacity>
            </View>
          </View>
        ))}
      </View>
    </ScrollView>
  )
}
